import _createClass from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _inherits from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import { ProviderLabel } from './types.js';
export var ProviderRpcError = /*#__PURE__*/function (_Error) {
  _inherits(ProviderRpcError, _Error);

  var _super = _createSuper(ProviderRpcError);

  function ProviderRpcError(error) {
    var _this;

    _classCallCheck(this, ProviderRpcError);

    _this = _super.call(this, error.message);
    _this.message = error.message;
    _this.code = error.code;
    _this.data = error.data;
    return _this;
  }

  return _createClass(ProviderRpcError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var remove = function remove(_ref) {
  var detected = _ref.detected,
      metamask = _ref.metamask;
  return function (_ref2) {
    var label = _ref2.label;
    return !(label === ProviderLabel.Detected && detected || label === ProviderLabel.MetaMask && metamask);
  };
};